import { useQuery } from 'react-query';

import { customInstance } from '@ping/api/custom-instance';

export interface WithdrawalLiquidityHint {
  enabled: boolean;
  paymentSystem: string;
  status: 'available' | 'queued' | 'liquidity_incoming';
  message?: string | null;
  pendingWithdrawalsUsdc: number;
  inFlightCctpInboundUsdc: number;
  withdrawalCoverageGap: number;
  estimatedLiquidityMinutes?: number | null;
  alternativePaymentSystem?: string | null;
  alternativePaymentSystemMessage?: string | null;
}

const getWithdrawalLiquidityHint = (paymentSystem: string, assetId?: string) =>
  customInstance<WithdrawalLiquidityHint>({
    url: '/frontoffice/api/wallet/withdrawal/liquidity-hint',
    method: 'GET',
    params: { paymentSystem, assetId },
  });

export const useWithdrawalLiquidityHint = (paymentSystem?: string, assetId?: string) =>
  useQuery(
    ['withdrawal-liquidity-hint', paymentSystem, assetId],
    () => getWithdrawalLiquidityHint(paymentSystem!, assetId),
    {
      enabled: Boolean(paymentSystem) && (assetId?.toLowerCase() === 'usdc' || !assetId),
      staleTime: 30_000,
    }
  );
